import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import PeopleIcon from "@mui/icons-material/People";
import PaymentsIcon from "@mui/icons-material/Payments";

import "./widget.scss";

const Widget = ({ type }) => {
  let data;
  const [userCount, setUserCount] = useState();
  const [investorsCount, setInvestorsCount] = useState();
  const [campCount, setCampCount] = useState();
  const [activeCount, setActiveCount] = useState();
  const [approveCount, setApproveCount] = useState();
  const token = localStorage.getItem("accessToken");

  const getUserCount = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-users-count",
      headers: {
        "x-access-token": token,
      },
    };
    axios(config)
      .then(function (response) {
        requestAnimationFrame(() => {
          setUserCount(response.data.data.user_count.total_user);
          setInvestorsCount(
            response.data.data.user_count.accreditedinvestor_count_total
          );
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCampCount = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-campaign-count",
      headers: {
        "x-access-token": token,
      },
    };
    axios(config)
      .then(function (response) {
        requestAnimationFrame(() => {
          setActiveCount(response.data.data.campaign_count.active_campaign);
          setApproveCount(
            response.data.data.campaign_count.in_initial_approval_campaign
          );
          setCampCount(response.data.data.campaign_count.total_campaign);
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getUserCount();
    getCampCount();
  }, []);

  switch (type) {
    case "accredited":
      data = {
        title: "Accredited Investors",
        isMoney: false,
        count: investorsCount,
        link: (
          <Link to="/accredited-investors" className="icon-link">
            See all accredited-investors
          </Link>
        ),
        icon: (
          <PaymentsIcon
            className="icon"
            style={{
              color: "#3e98c7",
              backgroundColor: "rgba(158,207,250,.3)",
            }}
          />
        ),
      };
      break;
    case "user":
      data = {
        title: "TOTAL USERS",
        isMoney: false,
        count: userCount,
        link: (
          <Link to="/users" className="icon-link">
            See all users
          </Link>
        ),
        icon: (
          <PeopleIcon
            className="icon"
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
            }}
          />
        ),
      };
      break;

    case "order":
      data = {
        title: "TOTAL CAMPAIGN",
        isMoney: false,
        count: campCount,
        link: (
          <Link to="/for-review-campaign" className="icon-link">
            View all campaigns
          </Link>
        ),
        icon: (
          <AddBusinessIcon
            className="icon"
            style={{
              backgroundColor: "rgba(218, 165, 32, 0.2)",
              color: "goldenrod",
            }}
          />
        ),
      };
      break;
    case "earning":
      data = {
        title: "INITIAL APPROVE",
        isMoney: true,
        count: approveCount,
        link: (
          <Link to="/initial-approve" className="icon-link">
            See details
          </Link>
        ),
        icon: (
          <DonutLargeIcon
            className="icon"
            style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
          />
        ),
      };
      break;
    case "balance":
      data = {
        title: "TOTAL ACTIVE",
        isMoney: true,
        count: activeCount,
        link: (
          <Link to="/active-campaign" className="icon-link">
            See details
          </Link>
        ),
        icon: (
          <AssuredWorkloadIcon
            className="icon"
            style={{
              backgroundColor: "rgba(128, 0, 128, 0.2)",
              color: "purple",
            }}
          />
        ),
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">{data.count}</span>
        <span className="link">{data.link}</span>
      </div>
      <div className="right">{data.icon}</div>
    </div>
  );
};

export default Widget;